import {BaseContainerModel} from '../../../base-container.model';
import {bl_del_driver_vehicle_link_RowClass} from '../../../../dbschema';

export class DriverVehicleLinkContainerModel extends BaseContainerModel {
  bl_del_driver_vehicle_link: bl_del_driver_vehicle_link_RowClass = new bl_del_driver_vehicle_link_RowClass();
}
